"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printDebugGen = exports.generate = void 0;
var schema_json_1 = __importDefault(require("./schema.json"));
var utils_1 = require("./utils");
function numberOrNull(v) {
    return typeof v === "number" ? v | 0 : null;
}
function generate(_a) {
    var _b = _a === void 0 ? {} : _a, race = _b.race, subrace = _b.subrace, classorprof = _b.classorprof, occupation1 = _b.occupation1, occupation2 = _b.occupation2, alignment = _b.alignment, plothook = _b.plothook, gender = _b.gender;
    var options = {
        race: numberOrNull(race),
        subrace: numberOrNull(subrace),
        classorprof: numberOrNull(classorprof),
        occupation1: numberOrNull(occupation1),
        occupation2: numberOrNull(occupation2),
        alignment: numberOrNull(alignment),
        plothook: numberOrNull(plothook),
        gender: numberOrNull(gender),
    };
    var context = { vars: {} };
    var debugNode = { o: "root", childs: [] };
    function processGroups(groups) {
        var result = "";
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var instruction = groups_1[_i];
            if (typeof instruction === "string") {
                debugNode.childs.push(instruction);
                result += String(instruction);
            }
            else {
                var oldNode = debugNode;
                if (utils_1.debugGen) {
                    var node = { o: instruction.original, childs: [] };
                    debugNode.childs.push(node);
                    debugNode = node;
                }
                if (typeof instruction === "function") {
                    var insRes = instruction(context, options);
                    if (insRes !== undefined) {
                        if (Array.isArray(insRes)) {
                            result += String(processGroups(insRes));
                        }
                        else {
                            result += String(insRes);
                        }
                    }
                }
                else if (Array.isArray(instruction)) {
                    result += String(processGroups(instruction));
                }
                debugNode = oldNode;
            }
        }
        return result;
    }
    function chooseFromArray(arr) {
        var totalWeight = arr.reduce(function (w, e) {
            return w + (e.w | 0);
        }, 0);
        return utils_1.chooseRandomWithWeight(arr, totalWeight);
    }
    function processSchema(schemaElement) {
        if (typeof schemaElement === "string") {
            return processGroups(utils_1.getGroups(schemaElement));
        }
        else if (Array.isArray(schemaElement)) {
            return processSchema(chooseFromArray(schemaElement));
        }
        var result = {};
        for (var _i = 0, _a = Object.keys(schemaElement); _i < _a.length; _i++) {
            var name = _a[_i];
            var element = schemaElement[name];
            // need to make a choice based on weight
            result[name] = processSchema(element);
        }
        return result;
    }
    // process inititalisation first, most of the selection is done here
    processGroups(utils_1.getGroups(schema_json_1.default.options.initialisation));
    // Force to Npc type because we know schema.output matches the Npc type
    var npc = processSchema(schema_json_1.default.output);
    return { npc: npc, debugNode: debugNode };
}
exports.generate = generate;
function printDebugGen(debugNode) {
    if (debugNode) {
        var depth_1 = 0;
        var lines_1 = [];
        var indent_1 = function () { return " ".repeat(depth_1); };
        var processNode_1 = function (node) {
            if (typeof node === "string") {
                lines_1.push(indent_1() + ("-> " + node));
            }
            else {
                lines_1.push(indent_1() + ("-> " + node.o));
                depth_1++;
                for (var _i = 0, _a = node.childs; _i < _a.length; _i++) {
                    var child = _a[_i];
                    processNode_1(child);
                }
                depth_1--;
            }
        };
        processNode_1(debugNode);
        console.log(lines_1.join("\n"));
    }
}
exports.printDebugGen = printDebugGen;
